<div class="inner cover">
	<h1 class="text-left">Forgot password?</h1>
	<p class="text-left login-gray-text login-description">Please enter your email address to reset your password.</p>
  <form class="" autocomplete="off" (ngSubmit)="onSend(f)" #f="ngForm" (keydown)="onKeyDownFunction($event, f)">
    <div class="form-group">
      <input
        type="email"
        id="email"
        name="email"
        ngModel
        class="form-control"
        autocomplete="off"
        aria-describedby="emailHelp"
        placeholder="Email">
    </div>
    <div class="col-xs-12 clearfix">
      <button data-testid="forgot-password-send" type="submit" class="btn btn-outline-primary btn-outline pull-left active login-button " [disabled]="!f.valid">Send</button>
    </div>
  </form>
  <div class="col-md-12 mx-auto text-left">
    <a [routerLink]="['/signin']" class="small login-gray-text dot-underline">Sign in</a><span class="small login-gray-text logout-separator">|</span><span class="small login-gray-text">Create a <a [routerLink]="['/signin']" class="dot-underline login-gray-text">new account</a></span>
  </div>
</div>
<app-footer></app-footer>
